
export default class SourceConfig {
    constructor(_config){
        
        this.congress= {
            'name':'congress-choro-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/congress_demographics/{z}/{x}/{y}?geom_column=geom&columns=geoid`]
            }
        }

        this.stateLegUpper= {
            'name':'statelegupper-choro-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/statelegupper_demographics/{z}/{x}/{y}?geom_column=geom&columns=geoid`]
            }
        }

        this.stateLegLower= {
            'name':'stateleglower-choro-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/stateleglower_demographics/{z}/{x}/{y}?geom_column=geom&columns=geoid`]
            }
        }

        this.tractCVAP = {
            'name':'tract-cvap-choro-source', 
            'data':{
                type: 'vector',
                url: "mapbox://cunycur.81xntks0",
                //url: "mapbox://cunycur.cdy5fioz",
            }
        }

        this.tractVAP = {
            'name':'tract-vap-choro-source', 
            'data':{
                type: 'vector',
                //url: "mapbox://cunycur.81xntks0",
                url: "mapbox://cunycur.cdy5fioz",
            }
        }
  
        this.fipsLabelCongressSource= {
            'name':'fips-labels-congress-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/congress_labels_us_centroids/{z}/{x}/{y}?geom_column=geom&columns=distname`]
            }
        }

        this.fipsLabelStLegUpperSource= {
            'name':'fips-labels-statelegupper-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/stateupper_labels_us_centroids/{z}/{x}/{y}?geom_column=geom&columns=stateupperlabel`]
            }
        }

        this.fipsLabelStLegLowerSource= {
            'name':'fips-labels-stateleglower-source', 
            'data':{
                type: 'vector',
                tiles: [`${_config.api.hosts.nodeHostAddress}/mvt/statelower_labels_us_centroids/{z}/{x}/{y}?geom_column=geom&columns=statelowerlabel`]
            }
        }

        // this.legislative = {
        //     'name':'legislative-choro-source', 
        //     'data':{
        //         type: 'vector',
        //         tiles: [`${_config.api.hosts.nodeHostAddress}/mvt_layered/congress_demographics%2Cstatelegupper_demographics%2Cstateleglower_demographics/{z}/{x}/{y}?geom_column=geom&columns=geoid`
        //         ]
        //     }
        // }

        // this.legislativeLabel = {
        //     'name':'legislative-label-source', 
        //     'data':{
        //         type: 'vector',
        //         tiles: [`${_config.api.hosts.nodeHostAddress}/mvt_layered/congress_labels_us_centroids%2Cstateupper_labels_us_centroids%2Cstatelower_labels_us_centroids/{z}/{x}/{y}?geom_column=geom&columns=distlabel`
        //         ]
        //     }
        // }

        this.voting = {
            'name': 'voting-precincts',
            'data':{
                type:'vector',
                tiles:[`${_config.api.hosts.nodeHostAddress}/mvt/nytimes2020precinctresults/{z}/{x}/{y}?geom_column=geom&columns=geoid,bidenpct`]
            }
        }
        
        this.sourceArray = [
           // this.legislative,
           this.congress,
            this.stateLegUpper,
            this.stateLegLower,
            this.tractCVAP, 
            this.tractVAP,
            this.voting,
            this.fipsLabelCongressSource, this.fipsLabelStLegUpperSource,this.fipsLabelStLegLowerSource];
    }
}